import { render, staticRenderFns } from "./AddPreProduct.vue?vue&type=template&id=371904ae&"
import script from "./AddPreProduct.vue?vue&type=script&lang=js&"
export * from "./AddPreProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports